import { Component } from '@angular/core';
import { OutOfOfficeService } from '../../../Model/OutOfOffice/out-of-office.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { CommonService } from '../../../Model/Common/common.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { RegularizationService } from '../../../Model/Regularization/regularization.service';
import { UserRightService } from '../../../Model/UserRight/user-right.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-out-of-office-approval-detail',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbDatepickerModule, DataTablesModule, RouterModule, LoaderComponent],
  templateUrl: './out-of-office-approval-detail.component.html',
  styleUrl: './out-of-office-approval-detail.component.scss'
})
export class OutOfOfficeApprovalDetailComponent {
  isDisabled: boolean = false;
  isSuper: boolean = false;//for super admin
  GetID = 0;//1-detail,2-request
  isApprovalLavel = true;
  DetailData = {
    WebESSApprovalRequestTrackingId: null as any,
    TransactionId: null,
    EmpMasterId: null,
    EmpMappingId: 0,
    EmpCode: null,
    Photo: null as any,
    EmployeeName: null as any,
    BranchName: null,
    ClientLocation: null,
    DesignationMasterId: null,
    DesignationName: null,
    ShiftMasterId: null,
    ShiftTitle: null,
    AttendanceDate: null,
    InTime: null,
    OutTime: null,
    Reason: null,
    Attachment: null,
    EmpType: null as any,
    ApprovalStatus: null as any,
    RequestDate: null,
    Date: null
  };

  Trackings = [];
  TrackingsUser = [];
  user = [] as any;

  Filter = {
    ModuleMasterId: 20,
    WebESSApprovalRequestTrackingId: 0,
    FromDate: null,
    ToDate: null,
    FromDateObj: null as any,
    ToDateObj: null as any,
    EmpMasterId: 0,
    EmpMappingId: 0,
    SelectType1: 'D',
    SelectType: null,
    TransactionId: 0,
    EmpType: null,
    Remark: null,
    isShowError: false,
  }

  constructor(
    private outofoffice: OutOfOfficeService,
    private approvalMatrix: ApprovalMatrixService,
    private route: ActivatedRoute,
    private session: SessionService,
    private toast: ToastService,
    private router: Router,
    protected common: CommonService,
    protected dateFormate: CustomDateParserFormatter,
    private modalService: NgbModal,
    //private regularization: RegularizationService,
    protected tooltip: TooltipService,
    private userright: UserRightService
  ) {
    this.user = this.session.GetUserDetails();
    this.common.getPageRights();
    // this.common.PageRight.IsView = true;
    // this.common.PageRight.IsAdd = true;
    // this.common.PageRight.IsDelete = true;
    // this.common.PageRight.IsEdit = true;
    // this.common.PageRight.IsPrint = true;
    this.route.params.subscribe(params => this.Filter.WebESSApprovalRequestTrackingId = parseInt(params['id']));
    if (window.location.pathname.includes('todo')) {
      this.GetID = 1;
    } else if (window.location.pathname.includes('request')) {
      this.GetID = 2
    }
    // this.router.events.subscribe((val:any) => { if(val instanceof ActivationEnd){
    //   this.ngOnInit();
    // }});
  }

  ngOnInit(): void {
    if (this.user.UserType == 'E') {
      this.Filter.EmpMappingId = this.user.UserId;
    }
    if (this.GetID == 1) {
      this.ApprovalMatrixRequestGet();
      //if (this.user.UserType == 'A') {
      this.ESS_GetUserRole();
      //}
    } else if (this.GetID == 2) {
      this.LoadOutofOfficeMaster();
    }
  }

  ApprovalMatrixRequestGet() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet(this.Filter).subscribe({
      next: (response) => {
        if (this.Filter.ModuleMasterId == 20) {
          if (response.Table.length > 0) {
            this.DetailData = response.Table[0];
          } else if (response.Table1.length > 0) {
            this.DetailData = response.Table1[0];
          } else if (response.Table2.length > 0) {
            this.DetailData = response.Table2[0];
          } else if (response.Table3.length > 0) {
            this.DetailData = response.Table3[0];
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.ApprovalMatrixRequestGetTracking();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestGetTracking() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet({ ModuleMasterId: this.Filter.ModuleMasterId, FromDate: '', ToDate: '', EmpMasterId: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, SelectType1: 'ApprovalStatus', SelectType: '', TransactionId: this.DetailData.TransactionId }).subscribe({
      next: (response) => {
        if (response.Table.length == 0) {
          this.isApprovalLavel = false;
        }
        if (this.common.ToLowerCase(this.DetailData.ApprovalStatus) == 'pending') {
          if (this.user.UserType == 'A') {
            this.TrackingsUser = response.Table.filter((e: any) => e.ApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.ApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          } else if (this.user.UserType == 'E') {
            this.TrackingsUser = response.Table.filter((e: any) => e.EmpApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.EmpApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          }
        } else {
          this.Trackings = response.Table.sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  // LoadOutofOfficeMaster() { 
  //   this.outofoffice.OutOfOfficeAttendanceDetails({ 
  //     ESS_OutOfOfficeAttendanceDetailsId: this.Filter.WebESSApprovalRequestTrackingId, SelectType: 2, EmpMasterID: this.user.UserId, FromDate: null, ToDate: null, ApprovalStatus: 'ALL' }).subscribe({
  //     next: (response) => {
  //       this.DetailData.WebESSApprovalRequestTrackingId = 0,
  //         this.DetailData.TransactionId = response[0].TransactionId,
  //         this.DetailData.EmpMasterId = response[0].EmpMasterId,
  //         this.DetailData.EmpCode = response[0].EmpCode,
  //         this.DetailData.Photo = response[0].Photo,
  //         this.DetailData.EmployeeName = response[0].EmployeeName,
  //         this.DetailData.BranchName = response[0].BranchName,
  //         this.DetailData.ClientLocation = response[0].ClientLocation,
  //         this.DetailData.DesignationMasterId = response[0].DesignationID,
  //         this.DetailData.DesignationName = response[0].DesignationName,
  //         this.DetailData.ShiftMasterId = response[0].ShiftID,
  //         this.DetailData.ShiftTitle = response[0].ShiftTitle,

  //         this.DetailData.Date = response[0].AttendanceDate,
  //         this.DetailData.InTime = response[0].InTime ,
  //         this.DetailData.OutTime = response[0].OutTime,
  //         this.DetailData.Reason =  response[0].Reason ,
  //         this.DetailData.Attachment = response[0].Attachment,
  //         this.DetailData.EmpType = this.user.EmpType,
  //         this.DetailData.ApprovalStatus = response[0].ApprovalStatus,
  //         this.DetailData.RequestDate = response[0].RequestDate
  //     },
  //     complete: () => {
  //       this.ApprovalMatrixRequestGetTracking();
  //     },
  //     error: (error) => { },
  //   });
  // }
  LoadOutofOfficeMaster() {
    this.DetailData.EmpType = this.user.EmpType,
      this.Filter.EmpMasterId = this.user.UserId;
    this.isDisabled = true
    this.outofoffice.OutOfOfficeAttendanceDetails({
      SelectType: 2,
      ESS_OutOfOfficeAttendanceDetailsId: this.Filter.WebESSApprovalRequestTrackingId,
      EmpMasterID: this.user.UserId,
      ApprovalStatus: 'All',
      FromDate: null,
      ToDate: null,
      BranchId: 0,
      ClientId: 0,
      SiteId: 0,
      AttendanceDate: 0,
    }).subscribe({
      next: (data) => {
        if (this.Filter.ModuleMasterId == 20) {
          if (data.Table.length > 0) {
            this.DetailData = data.Table[0];
          } else if (data.Table1.length > 0) {
            this.DetailData = data.Table1[0];
          } else if (data.Table2.length > 0) {
            this.DetailData = data.Table2[0];
          } else if (data.Table3.length > 0) {
            this.DetailData = data.Table3[0];
          }
        }
        else {
          this.isDisabled = false
        }
      },
      complete: () => {
        this.ApprovalMatrixRequestGetTracking();
        this.isDisabled = false
      },
      error: (error) => {
        this.isDisabled = false
        console.error('Error:', error);
      },
    });
  }
  ApprovalMatrixRequestProcess(SelectType: string) {
    if (((SelectType == 'Reject' && this.Filter.Remark != '' && this.Filter.Remark != null) || SelectType == 'Approve') || this.isSuper) {
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = 'Do you want to ' + SelectType + '?';
      modalRef.result.then((result: any) => {
        if (result) {
          this.isDisabled = true;
          //this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, approvedid: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
          this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
            next: (response) => {
              if (response.Error_Code == '49' || response.Error_Code == '50' || response.Error_Code == '51') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.router.navigate(['/todo/outofofficeapproval/']);
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      }).catch(() => { });
    } else {
      this.Filter.isShowError = true;
      this.toast.show({ message: 'Please enter remark', type: toastTypeEnum.warning });
    }
  }

  Cancel() {
    if (this.GetID == 1) {
      if (this.user.UserType == 'A') {
        this.router.navigate(['/todo/outofofficeapproval/']);
      } else if (this.user.UserType == 'E') {
        this.router.navigate(['/request/outofoffice/approval/']);
      }
    } else if (this.GetID == 2) {
      this.router.navigate(['/request/outofoffice/']);
    }
  }

  ESS_GetUserRole() {
    this.isDisabled = true;
    try {
      this.userright.ESS_GetUserRole({ SelectType: 'S', EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
        next: (response) => {
          if (this.common.ToLowerCase(response.Table[0].UserRole) == 'superadmin') {
            this.isSuper = true;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } catch (e) {
      this.isDisabled = false;
    }
  }
  Link(Text: string) {
    return this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'OutofOffice' + '/' + Text;
  }

  SaveWithdrawmDetails() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to withdraw?';
    modalRef.result.then(result => {
      if (this.common.PageRight.IsAdd) {
        if (result) {
          this.isDisabled = true
          this.outofoffice.OutOfOfficeAttendanceDetailsInsert({ SelectType: 'WITHDRAWN', ESS_OutOfOfficeAttendanceDetailsID: this.Filter.WebESSApprovalRequestTrackingId, }).subscribe({
            next: (response) => {
              if (response.Error_Code == '660') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.Cancel();
                  }
                });
              }
              else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    });
  }

  removeError() {
    this.Filter.isShowError = false;
  }
}
